import { $logger } from '@/lib/logger';
import { isEmeaLiteCountry } from '@/lib/globals';
import { camelToSnakeCase } from '@/lib/utils';

const getBillingAgreementKey = type => {
  const key = isEmeaLiteCountry() ? `${type}EmeaLite` : type;
  return `billingAgreement.${key}`;
};

const logTermClick = linkName => {
  const snakedLinkName = camelToSnakeCase(linkName);
  const eventName = `prepare_${snakedLinkName}_terms`;
  $logger.fpti(`${eventName}`, {
    state_name: 'signup',
    transition_name: eventName,
  });
};

//helper function to create appropriate billing agreement key
const mapBillingFlowToContentKey = type => {
  switch (type) {
    case 'CHANNEL_INITIATED_BILLING_SINGLE_AGREEMENT':
    case 'CHANNEL_INITIATED_BILLING':
      return 'customerInitiated';
    case 'MERCHANT_INITIATED_SINGLE_BILLING':
    case 'MERCHANT_INITIATED_BILLING':
      return 'merchantInitiated';
  }
};

export { getBillingAgreementKey, logTermClick, mapBillingFlowToContentKey };
